export enum ApiFamily {
  THIRD_PARTY = 'THIRD_PARTY',
  REGULAR = 'REGULAR',
}
